import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAssignedLeads,
  fetchLeadsCount,
} from "../redux/callerSlice/leadsSlice";
import { Box, Typography, Paper } from "@mui/material";
import { fetchMyDeals } from "../redux/callerSlice/dealsSlice";
import { useNavigate } from "react-router-dom";

const OverViewCards = () => {
  const dispatch = useDispatch();
  const leadsCount = useSelector((state) => state.leads.leadsCount);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(fetchAssignedLeads());
  }, [dispatch]);

  const dealsCount = useSelector((state) => state.deals.dealsCount);

  useEffect(() => {
    dispatch(fetchMyDeals());
  }, [dispatch]);

  const handlenavigatelead = () => {
    navigate("/caller-dashboard/assignedleads");
  };

  const handlenavigatedeal = () => {
    navigate("/caller-dashboard/my-deals");
  };

  // Calculate conversion ratio
  const conversionRatio =
    dealsCount > 0
      ? ((dealsCount / (dealsCount + leadsCount)) * 100).toFixed(0)
      : 0;

  return (
    <div class="grid items-center justify-center grid-cols-1 md:grid-cols-2 lg:px-4 lg:grid-cols-4 gap-4 mb-4">
      <div class="bg-red-300 p-4 rounded-lg" onClick={handlenavigatedeal}>
        <div class="text-black">Total Deals</div>
        <div class="text-2xl font-bold">{dealsCount}</div>
      </div>

      <div class="bg-green-300 p-4 rounded-lg" onClick={handlenavigatelead}>
        <div class="text-black ">Pending Leads</div>
        <div class="text-2xl font-bold">{leadsCount}</div>
      </div>

      <div className="bg-blue-300 p-4 rounded-lg">
        <div className="text-black">Conversion Ratio</div>
        <div className="text-2xl font-bold">{conversionRatio}%</div>
      </div>
    </div>
  );
};

export default OverViewCards;
